module.exports = __webpack_public_path__ + "static/media/simSetup.a7958fca.png";